import React, { Component } from 'react'
import Carousel from '@components/carousel'
import { BannerPlaceholder } from '@components/placeholder/banner-placeholder'
import { banners as dummyDataBanners } from '@components/placeholder/const'

import { CarouselWrapper, carouselContainer } from './style'

class CarouselContainer extends Component {
  state = {
    carouselHeight: 0,
  }

  componentDidMount() {
    if (window) {
      window.addEventListener('resize', this.updateCarouselHeight)
    }
  }

  updateCarouselHeight = () => {
    this.setState({
      isResized: true,
    })
  }

  handleCarouselHeight = height => {
    this.setState({
      carouselHeight: height,
    })
  }

  componentWillUnmount() {
    if (window) {
      window.removeEventListener('resize', this.updateCarouselHeight)
    }
  }

  render() {
    const { carouselHeight, isResized } = this.state
    const { banners, isMobile } = this.props,
      viewportWidth = window ? window.innerWidth : 1200

    let desktopHeight = '38rem'
    if (viewportWidth > 1900) {
      desktopHeight = '60rem'
    } else if (viewportWidth > 1600) {
      desktopHeight = '52rem'
    } else if (viewportWidth > 1400) {
      desktopHeight = '44rem'
    } else if (viewportWidth > 1240) {
      desktopHeight = '38rem'
    } else if (viewportWidth > 1000) {
      desktopHeight = '30rem'
    }
    const carouselWrapperHeight = carouselHeight ? '0px' : isMobile ? '185px' : desktopHeight
    return (
      <>
        {/* {banners.meta.status !== 'success' &&
          <BannerPlaceholder isMobile={isMobile} data={dummyDataBanners} />
        } */}
        {banners.data.length > 0 && (
          <CarouselWrapper minHeight={carouselWrapperHeight} isResized={isResized}>
            <Carousel
              className={carouselContainer}
              wrap={banners.data.length === 1 ? false : true}
              sliderCoin={true}
              dragging={true}
              autoplay={true}
              slidesToShow={isMobile ? 1.25 : 1.732}
              transitionMode={'scroll3d'}
              withoutControls={banners.data.length < 2}
              cellSpacing={isMobile ? 8 : 16}
              framePadding="0rem"
              carouselHeightCallback={this.handleCarouselHeight}
            >
              {this.props.children}
            </Carousel>
          </CarouselWrapper>
        )}
      </>
    )
  }
}

export default CarouselContainer
